import Icon, { IconProps } from './Icon';

import ShareIcon from '../../../assets/icons/share-07.svg?react';

const Share: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <ShareIcon />
    </Icon>
  );
};

export default Share;
